import permissions from 'constants/permissions'

const TASK_LIST = [
  {
    name: 'Visualizar',
    tag: permissions.TASKS.VIEW,
  },
  {
    name: 'Criar',
    tag: permissions.TASKS.CREATE,
  },
  {
    name: 'Atualizar',
    tag: permissions.TASKS.UPDATE,
  },
  {
    name: 'Excluir',
    tag: permissions.TASKS.DESTROY,
  },
]

export default TASK_LIST
